import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TextInput } from '@telialt/common-text-input/src';

import { LEAD_TEST_IDS } from '../constants';
import { LeadFieldName } from '../model';

type Props = { initialValue?: string };

export const CompanyCodeNameField: FC<Props> = ({ initialValue = '' }) => {
    const { t } = useTranslations();

    return (
        <TextInput
            label={t['content.lead.company_name.label']}
            defaultValue={initialValue}
            required={true}
            requiredErrorMessage={t['content.lead.company_name.required_error_message']}
            name={'companyCodeName' as LeadFieldName}
            dataTest={LEAD_TEST_IDS.FIELD_COMPANY_CODE}
        />
    );
};
